<template>
  <div>
    <Card dis-hover>

      <div class="query">
        <!-- <Divider orientation="left" style="position: relative;top: -12px;">查询条件
        </Divider> -->
        <Form :model="queryForm" label-position="right" ref="infoFrom" :label-width="120" inline>
          <FormItem prop="applicationNo" label="流水号">
            <Input type="text" v-model.trim="queryForm.applicationNo" placeholder="请输入" style="width: 200px">
            </Input>
          </FormItem>
          <FormItem prop="applicantName" label="申请人姓名">
            <Input type="text" v-model.trim="queryForm.applicantName" placeholder="请输入" style="width: 200px">
            </Input>
          </FormItem>
          <FormItem prop="wxOpenld" label="申请人身份证号">
            <Input type="text" v-model.trim="queryForm.applicantIDCardNo" placeholder="请输入" style="width: 200px">
            </Input>
          </FormItem>

          <FormItem prop="time" label="业务状态">
            <Select v-model="queryForm.status" style="width:200px">
              <Option value=""> -- </Option>
              <Option v-for="item in statusList" :value="item.value" :key="item.value">{{ item.text }}</Option>
            </Select>
          </FormItem>
          <!-- <FormItem prop="time" label="申请时间">
            <DatePicker type="daterange" @on-change="dateChange()" :editable="false" v-model="queryForm.time" :start-date="new Date()" placement="bottom-end" placeholder="请选择" style="width: 200px" />
          </FormItem> -->

          <FormItem class="button function">
            <Button type="primary" @click="queryTable()" icon="md-search">查询</Button>

            <Button @click="refresh('infoFrom')" icon="md-refresh">重置</Button>
          </FormItem>
        </Form>
      </div>
      <div class="table_btn">

        <div class="tab_a" id="printDiv">
          <Table border stripe :loading="loading" ref="selection" no-data-text="暂无数据" :columns="columns" :data="data">

            <template slot-scope="{ row }" slot="action">
              <Button @click="openDetail(row.guid,row.applicationType)" type="info" ghost style="margin-right: 5px;margin-top: 5px">详情</Button>
              <Button @click="openEdit(row.guid,row.applicationType)" type="warning" ghost v-if="row.allowUpdate" style="margin-right: 5px;margin-top: 5px">修改</Button>
              <Button @click="sendBackGR(row.guid,row.applicationType)" ghost type="warning" v-if="row.allow退回个人" style="margin-right: 5px;margin-top: 5px">退回个人</Button>
              <Button @click="deleteHandler(row.guid,row.applicationType)" ghost type="error" v-if="row.allowDelete" style="margin-right: 5px;margin-top: 5px">删除</Button>
              <!-- <Button @click="openDownLoad(row.guid)" type="warning" ghost style="margin-right: 5px">下载调档函</Button> -->
              <Button @click="subDownLoad(row.guid,row.applicationType)" type="warning" ghost v-if="row.allow下载调档函" style="margin-right: 5px;margin-top: 5px">下载调档函</Button>
              <Button @click="notifyEnterprise(row.guid,row.applicationType)" type="warning" ghost v-if="row.allow_查看材料清单" style="margin-right: 5px;margin-top: 5px">查看材料清单</Button>
              <Button @click="openMail(row.guid,row.applicationType)" type="warning" ghost v-if="row.allow已邮寄调档函" style="margin-right: 5px;margin-top: 5px">已邮寄调档函</Button>
              <Button @click="uploadPersonFile(row.guid)" type="warning" v-if="row.allow单位上传调档结果" ghost style="margin: 5px 5px 5px 0px">上传核档结果</Button>

              <Button @click="openSupplement(row.guid,row.applicationType)" type="warning" ghost v-if="row.allow补充材料" style="margin-right: 5px;margin-top: 5px">补充材料</Button>
              <Button @click="openArchivesSupplement(row.guid,row.applicationType)" type="warning" ghost v-if="row.allow补交档案材料" style="margin-right: 5px;margin-top: 5px;margin-buttom: 5px">补交档案材料</Button>
              <Button @click="openEducationSupplement(row.guid,row.applicationType)" type="warning" ghost v-if="row.allow补交最高学历材料" style="margin-right: 5px;margin-top: 5px;margin-buttom: 5px">补交最高学历材料</Button>
              <Button @click="openJuniorCollegeSupplement(row.guid,row.applicationType)" type="warning" ghost v-if="row.allow补交专科学历材料" style="margin-right: 5px;margin-top: 5px;margin-buttom: 5px">补交专科学历材料</Button>

            </template>
          </Table>
        </div>
        <div class="page_btn">
          <Page :total="page.total" show-elevator show-total show-sizer v-model="page.current" @on-prev="pageCurrent" @on-next='pageCurrent' @on-page-size-change="pageSizeChange" @on-change="pageCurrent" />
        </div>

      </div>
    </Card>
    <Modal v-model="showPropress" width="460" title="下载调档函">
      <div>
        请下载档案核实函及档案核实情况表并邮寄。
      </div>
      <template #footer>
        <Button type="primary" @click="subDownLoad">开始下载</Button>
      </template>
    </Modal>
    <Modal v-model="showPersonFile" width="460" :closable="false" :mask-closable="false" title="上传核档结果">
      <Form ref="formUpLoad" :model="formUpLoad" :rules="ruleInline">
        <FormItem prop="transferResultFileGuidList">
          <Upload ref="upLoadPersonFile" :action="$baseURL + '/common/file/uploadfile'" multiple type="drag" :on-preview="handlePreview" :on-remove="
                (file, fileList) =>
                  handleRemove(file, fileList)
              " :on-success="
                (response, file, fileList) =>
                  handleSuccess(
                    response,
                    file,
                    fileList,
                  )
              " :on-format-error="handleFormatError">
            <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p>上传文件</p>
            </div>
          </Upload>
        </FormItem>
        <Spin size="large" fix v-if="formInlineLoading"></Spin>
      </Form>
      <template #footer>
        <Button @click="closePersonFile">关闭</Button>
        <Button type="primary" @click="subUploadPersonFile">确定</Button>
      </template>
    </Modal>
    <div v-if="notifyEnterpriseShow">
      <notify-enterprise-submit-material :show="notifyEnterpriseShow" @close="notifyEnterpriseClose" :loading="notifyEnterpriseLoading" :model="form" />

    </div>
  </div>
</template>

<script>
// import Detail from '../detail/index.vue'
import NotifyEnterpriseSubmitMaterial from './modules/notifyEnterpriseSubmitMaterial'

export default {
  components: {
    //  ProgressBar,
    NotifyEnterpriseSubmitMaterial,
  },
  data() {
    return {
      showPersonFile: false,
      accept: '.xls, .xlsx',
      notifyEnterpriseShow: false,
      notifyEnterpriseLoading: false,
      loading: false,
      showDetail: false,
      detailId: null,
      detailTitle: '',
      appSourceTypeList: [],
      statusList: [],
      formUpLoad: { guid: null, transferResultFileGuidList: [] },
      formInlineLoading: false,
      ruleInline: {
        remark: [{ required: true, message: '不能为空', trigger: 'change' }],
        transferResultFileGuidList: [
          { required: true, message: '不能为空', type: 'array', trigger: 'change' },
        ],
      },
      progress: 0,
      downLoadGuid: '',
      showPropress: false,
      form: { materialStateInfoList: [] },
      queryForm: {
        query_新办个人查询: true,
        // wxOpenId: '',
        // startCreateTime: '',
        // endCreateTime: '',
        // testType: '',
        // time: [],
      }, //查询参数
      page: {
        //分页参数
        total: 0,
        current: 0,
        skipCount: 0,
        maxResultCount: 10,
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          align: 'center',
          width: 80,
        },
        {
          title: '流水号',
          key: 'applicationNo',
        },
        {
          title: '申请人姓名',
          key: 'applicantName',
        },
        {
          title: '身份证号码',
          key: 'applicantIDCardNo',
          // minWidth: 185,
        },

        {
          title: '提交时间',
          key: 'submitTime',
          render: (h, params) => {
            return h('div', [
              h(
                'span',
                params.row.submitTime
                  ? this.$moment(params.row.submitTime).format('yyyy-MM-DD HH:mm')
                  : ''
              ),
            ])
          },
        },
        {
          title: '状态',
          key: 'portalStatusText',
        },
        {
          title: '操作',
          slot: 'action',
          width: 370,
        },
      ],
      data: [],
      types: [],
    }
  },
  mounted() {
    this.getData()
    this.getSelectList()
  },
  methods: {
    queryTable() {
      this.page = {
        //分页参数
        total: 0,
        current: 0,
        skipCount: 0,
        maxResultCount: 10,
      }
      this.getData()
    },
    async getSelectList() {
      let { data } = await this.$Ajax.get('/api/services/app/JZZJFApi/GetBasicData')
      console.log('🚀 ~ file: index.vue:213 ~ getSelectList ~ data:', data)
      this.appSourceTypeList = data.result.appSourceTypeList
      this.statusList = data.result.applicationStatusList
    },
    //分页 改变当前页码
    pageCurrent(current) {
      this.page.current = current
      this.page.skipCount = (current - 1) * this.page.maxResultCount
      this.getData()
    },
    //分页改变每页条数
    pageSizeChange(pageSizeChange) {
      this.page.maxResultCount = pageSizeChange
      this.pageCurrent(1)
    },
    //获取所有类型

    //时间格式化
    dateChange() {
      let time = this.queryForm.time
      console.log('🚀 ~ file: article.vue:257 ~ dateChange ~ time:', time)
      let start = time[0] ? this.$moment(time[0]).format('YYYY-MM-DD  HH:mm:ss') : ''
      let end = time[1] ? this.$moment(time[1]).format('YYYY-MM-DD  HH:mm:ss') : ''
      this.queryForm.startCreateTime = start
      this.queryForm.endCreateTime = end
    },
    //打开详情
    openDetail(guid, applicationType) {
      if (applicationType == this.$store.state.applicationType['有效期内添加同住人']) {
        this.$router.push({ name: 'addWithinValidityFamilyDetail', query: { guid } })
        return
      }
      if (applicationType == this.$store.state.applicationType['居住证积分新办']) {
        this.$router.push({ name: 'pointsNewDetail', query: { guid } })
      }
    },
    //打开编辑
    openEdit(guid, applicationType) {
      if (applicationType == this.$store.state.applicationType['有效期内添加同住人']) {
        this.$router.push({ name: 'addWithinValidityFamily', query: { guid } })
        return
      }
      if (applicationType == this.$store.state.applicationType['居住证积分新办']) {
        this.$router.push({ name: 'pointsNew', query: { guid } })
      }
    },
    //补交材料
    openSupplement(guid, applicationType) {
      this.$router.push({ name: 'pointsNewSupplement', query: { guid } })
    },
    //补交档案材料
    openArchivesSupplement(guid, applicationType) {
      this.$router.push({ name: 'pointsArchivesSupplement', query: { guid } })
    },
    //补交学历材料
    openEducationSupplement(guid, applicationType) {
      this.$router.push({ name: 'pointsEducationSupplement', query: { guid } })
    },
    //补交专科材料
    openJuniorCollegeSupplement(guid, applicationType) {
      this.$router.push({ name: 'pointsJuniorCollegeSupplement', query: { guid } })
    },
    //下载调档函
    openDownLoad(guid) {
      this.showPropress = true
      let _this = this
      this.downLoadGuid = guid
    },
    //确认下载
    async subDownLoad(guid) {
      let _this = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>请下载档案核实函及档案核实情况表并邮寄</p>',
        okText: '下载',
        cancelText: '否',
        onOk: async () => {
          this.$Ajax
            .get('/jzzjf/jzzjfapi/DownloadDDH?guid=' + guid, {
              // responseType: 'blob',
            })
            .then((response) => {
              console.log('🚀 ~ .then ~ response:', response)
              // const url = window.URL.createObjectURL(new Blob([response.data]))
              // const link = document.createElement('a')
              // link.href = url
              // link.setAttribute('download', 'file.pdf')
              // document.body.appendChild(link)
              // link.click()
              window.location.href = _this.$baseURL + response.data.result
              _this.$Message.success({
                content: '下载成功',
                background: true,
                duration: 6,
              })
              _this.getData()
            })

            .catch((error) => {
              _this.showPropress = false
              _this.$Message.error({
                content: '下载失败',
                background: true,
                duration: 6,
              })
            })
        },
        onCancel: () => {
          //否，个人信息变更
          //this.$emit('next', _this.current_index + 1)
        },
      })

      // this.showPropress = false
    },
    //关闭线下提交材料清单
    notifyEnterpriseClose() {
      this.notifyEnterpriseShow = false
      this.form.materialStateInfoList = { materialStateInfoList: [] }
    },
    //获取线下提交材料
    async notifyEnterprise(guid, type) {
      this.form = { materialStateInfoList: [] }
      this.notifyEnterpriseShow = true
      this.notifyEnterpriseLoading = true
      let { data } = await this.$Ajax.get(
        '/api/services/app/JZZJFApi/GetEnterpriseSubmitMaterialList',
        {
          params: { guid },
        }
      )
      console.log('🚀 ~ file: index.vue:213 ~ getSelectList ~ data:', data)
      this.form.materialStateInfoList = data.result
      this.form.guid = guid
      this.form.type = type
      this.notifyEnterpriseLoading = false
    },
    //邮寄调档函
    openMail(guid) {
      let _this = this
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否邮寄档案核实函及档案核实情况表</p>',
        okText: '是',
        cancelText: '否',
        onOk: async () => {
          // 是 直接提交
          try {
            let { data } = await _this.$Ajax.get(
              '/api/services/app/JZZJFApi/MailedFilesVerification?guid=' + guid
            )
            _this.$Message.success({
              content: '操作成功',
              background: true,
              duration: 6,
            })
            _this.getData()
          } catch (error) {
            _this.$Message.error({
              content: '操作失败',
              background: true,
              duration: 6,
            })
          }
        },
        onCancel: () => {
          //否，个人信息变更
          //this.$emit('next', _this.current_index + 1)
        },
      })
    },
    //上传调档结果
    uploadPersonFile(guid) {
      this.formUpLoad.guid = guid
      this.showPersonFile = true
    },
    handleSuccess(response) {
      if (!Array.isArray(this.formUpLoad.transferResultFileGuidList)) {
        //不存在先创建
        this.$set(this.formUpLoad, property, [])
      }
      this.formUpLoad.transferResultFileGuidList.push(response.result.guid)
    },
    handleRemove(file, fileList) {
      let guid = 0

      try {
        if (file.guid) {
          guid = file.guid
        } else if (file.response) {
          guid = file.response.result.guid
        }
      } catch (error) {
        guid = 0
      }

      let arrIndex = this.formUpLoad.transferResultFileGuidList.indexOf(guid)
      if (arrIndex !== -1) {
        this.formUpLoad.transferResultFileGuidList.splice(arrIndex, 1)
      }
    },
    //查看文件
    handlePreview(file) {
      let _this = this
      if (file.url) {
        let fileExtension
        if (file.name.indexOf('.') >= 0) {
          fileExtension = file.name.split('.').pop().toLowerCase()
        } else {
          fileExtension = ''
        }
        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
          const $viewer = this.$viewerApi({
            options: {
              toolbar: true,
              initialViewIndex: 0,
            },
            images: [_this.$baseURL + file.url],
          })
          return
        } else if (fileExtension === 'pdf') {
          this.$pdfPreview(true, _this.$baseURL + file.url)
          return
          // this.$pdfPreview
        }
        window.open(this.$baseURL + file.url)
        return
      }
      if (file.status == 'finished') {
        let fileExtension
        if (file.name.indexOf('.') >= 0) {
          fileExtension = file.name.split('.').pop().toLowerCase()
        } else {
          fileExtension = ''
        }
        if (fileExtension === 'jpg' || fileExtension === 'jpeg' || fileExtension === 'png') {
          const $viewer = this.$viewerApi({
            options: {
              toolbar: true,
              initialViewIndex: 0,
            },
            images: [_this.$baseURL + file.response.result.imageUrl],
          })
          return
        }
        window.open(this.$baseURL + file.response.result.imageUrl)
      }
    },
    //关闭上传调档结果
    closePersonFile() {
      this.showPersonFile = false
      this.formUpLoad.transferResultFileGuidList = []
      this.$refs.upLoadPersonFile.clearFiles()
      this.$refs.formUpLoad.resetFields()
    },
    //提交上传调档结果
    subUploadPersonFile() {
      let _this = this
      this.$refs.formUpLoad.validate(async (valid) => {
        if (valid) {
          try {
            _this.formInlineLoading = true
            let { data } = await this.$Ajax.post(
              '/api/services/app/JZZJFApi/UploadTransferResultByFilesVerification',
              _this.formUpLoad
            )
            // window.gsplugin.fillZSHSData(data.result)
            _this.$Message.success({
              content: '操作成功',
              background: true,
              duration: 6,
            })
            _this.formInlineLoading = false
            this.closePersonFile()
            this.getData()
          } catch (error) {
            _this.formInlineLoading = false
            this.$Message.error({
              content: '操作失败',
              background: true,
              duration: 6,
            })
          }
        } else {
          this.$Message.error('请上传核档结果!')
        }
      })
    },
    // 删除信息
    deleteHandler(guid) {
      let _this = this
      this.$Modal.confirm({
        title: '确定删除此申请吗',
        okText: '是',
        cancelText: '否',
        onOk: async () => {
          // 是 直接提交
          let { data } = await _this.$Ajax.get(
            'api/services/app/JZZJFApi/DelApplication?guid=' + guid
          )
          _this.$Message.success({
            content: '删除成功',
            background: true,
            duration: 6,
          })
          _this.getData()
        },
        onCancel: () => {
          //否，个人信息变更
          //this.$emit('next', _this.current_index + 1)
        },
      })
    },

    // 退回个人
    sendBackGR(guid, applicationType) {
      let _this = this
      this.$Modal.confirm({
        title: '确定将次申请退回个人吗',
        okText: '是',
        cancelText: '否',
        onOk: async () => {
          // 是 直接提交
          let { data } = await _this.$Ajax.post(
            '/api/services/app/JZZJFApi/BackToPerson?guid=' + guid
          )
          _this.$Message.success({
            content: '退回成功',
            background: true,
            duration: 6,
          })
          _this.getData()
        },
        onCancel: () => {
          //否，个人信息变更
          //this.$emit('next', _this.current_index + 1)
        },
      })
    },
    //查询
    async getData() {
      this.loading = true
      let params = { ...this.queryForm, ...this.page }
      let { data } = await this.$Ajax.post('/api/services/app/JZZJFApi/GetApplicationList', params)
      if (data.success) {
        this.page.total = data.result.totalCount
        this.data = data.result.items
      }
      this.loading = false
    },
    //重置
    refresh(name) {
      this.$refs[name].resetFields()

      if ((name = 'infoFrom')) {
        this.queryForm = {
          query_新办个人查询: true,
          wxOpenId: '',
          startCreateTime: '',
          endCreateTime: '',
          TestType: this.testType,
          time: [],
        } //查询参数
        this.page = {
          //分页参数
          total: 0,
          current: 1,
          skipCount: 0,
          maxResultCount: 10,
        }

        this.getData()
      }
    },

    downLoad(url, name) {
      this.$downLoad(url, name)
    },
  },
}
</script>

<style lang="less" scoped>
.g {
  color: green;
}
.r {
  color: rgb(153, 153, 153);
}
.o {
  color: orange;
}
.editForm {
  .ivu-form-item {
    margin-right: 58px;
  }
}
.ivu-page {
  margin-top: 20px;
}
.role {
  .ivu-switch {
    margin-right: 10px;
  }
}

.table_btn {
  margin-top: 10px;
}
.ivu-divider-horizontal.ivu-divider-with-text-left,
.ivu-divider-horizontal.ivu-divider-with-text-right {
  font-size: 16px;
  color: #57a3f3;
}
.page_btn {
  display: flex;
}
.page_button {
  margin-top: 20px;
  button {
    margin-right: 10px;
  }
}
.divi {
  cursor: pointer;
}
.tab_btn {
  display: flex;
  justify-content: right;
  margin-bottom: 5px;
}

.button {
  * {
    margin-right: 10px;
  }
}
.ivu-alert-icon2 {
  font-size: 16px;
  top: 6px;
  left: 12px;
}
.function /deep/.ivu-form-item-content {
  margin-left: 10px !important;
}
/deep/.ivu-alert-icon {
  font-size: 16px;
  top: 8px;
  left: 12px;
  position: absolute;
}

/deep/.ivu-table-expanded-cell {
  padding: 0px 0px 0px 50px;
}
/deep/.rowClassName {
  background-color: #f8f8f9 !important;
  color: rgb(0, 0, 0);
}
// /deep/.ivu-table-expanded-cell /deep/td {
//   background: orange;
// }
</style>

       